import {
  Tenant,
  TenantBankAccountEditFormValues,
  TenantCreateFormValues,
  TenantEditFormValues,
  TenantSearchFormValues,
  TenantType,
  TenantUserFormValues,
  Timezone,
} from "./types";

/**
 * IBAN tenanta za dokumente — primarni bankovni račun, pa bilo koji, uz fallback na staru
 * `transactionAccountNumber` kolonu za tenante prije uvođenja liste računa.
 * Prati `UserManager.GetPrimaryIbanAsync` na backendu.
 */
export const getPrimaryIban = (tenant?: Tenant | null): string | null => {
  if (!tenant) return null;

  const accounts = tenant.bankAccounts ?? [];
  const primary = accounts.find((account) => account.primary) ?? accounts[0];

  return primary?.iban || tenant.transactionAccountNumber || null;
};

export const initialTenantSearchForm: TenantSearchFormValues = {
  search: "",
};

export const initialTenantCreateForm: TenantCreateFormValues = {
  id: null,
  tenantTypeId: null,
  companyName: null,
  firstName: null,
  lastName: null,
  headquartersAddress: null,
  address: null,
  phoneNumber: null,
  mobilePhoneNumber: null,
  email: null,
  web: null,
  personalIdentificationNumber: null,
  timezone: "Europe/Zagreb",
  logo: [],
};

export const initialTenantUserForm: TenantUserFormValues = {
  firstName: null,
  lastName: null,
  email: null,
  password: null,
  confirmPassword: null,
  roleId: null,
};

export const initialTenantEditForm: TenantEditFormValues = {
  id: null,
  tenantTypeId: null,
  companyName: null,
  firstName: null,
  lastName: null,
  headquartersAddress: null,
  address: null,
  phoneNumber: null,
  mobilePhoneNumber: null,
  email: null,
  web: null,
  personalIdentificationNumber: null,
  transactionAccountNumber: null,
  timezone: null,
  logo: [],
};


export const initialTenantBankAccountEditForm: TenantBankAccountEditFormValues = {
  iban: "",
  bankName: null,
  description: null,
  primary: false,
};

export const initialTenantTypes: TenantType[] = [
  {
    id: "C",
    name: "Tvrtka",
  },
  {
    id: "P",
    name: "Osoba",
  },
];

export const timezones: Timezone[] = [
  { id: "Europe/Zagreb", name: "Europe/Zagreb (GMT+1)" },
  { id: "Europe/London", name: "Europe/London (GMT+0)" },
  { id: "Europe/Paris", name: "Europe/Paris (GMT+1)" },
  { id: "Europe/Berlin", name: "Europe/Berlin (GMT+1)" },
  { id: "Europe/Rome", name: "Europe/Rome (GMT+1)" },
  { id: "Europe/Vienna", name: "Europe/Vienna (GMT+1)" },
  { id: "Europe/Brussels", name: "Europe/Brussels (GMT+1)" },
  { id: "Europe/Amsterdam", name: "Europe/Amsterdam (GMT+1)" },
  { id: "Europe/Madrid", name: "Europe/Madrid (GMT+1)" },
  { id: "Europe/Lisbon", name: "Europe/Lisbon (GMT+0)" },
  { id: "Europe/Athens", name: "Europe/Athens (GMT+2)" },
  { id: "Europe/Bucharest", name: "Europe/Bucharest (GMT+2)" },
  { id: "Europe/Budapest", name: "Europe/Budapest (GMT+1)" },
  { id: "Europe/Prague", name: "Europe/Prague (GMT+1)" },
  { id: "Europe/Warsaw", name: "Europe/Warsaw (GMT+1)" },
  { id: "Europe/Stockholm", name: "Europe/Stockholm (GMT+1)" },
  { id: "Europe/Oslo", name: "Europe/Oslo (GMT+1)" },
  { id: "Europe/Copenhagen", name: "Europe/Copenhagen (GMT+1)" },
  { id: "Europe/Helsinki", name: "Europe/Helsinki (GMT+2)" },
  { id: "Europe/Dublin", name: "Europe/Dublin (GMT+0)" },
  { id: "America/New_York", name: "America/New York (GMT-5)" },
  { id: "America/Chicago", name: "America/Chicago (GMT-6)" },
  { id: "America/Denver", name: "America/Denver (GMT-7)" },
  { id: "America/Los_Angeles", name: "America/Los Angeles (GMT-8)" },
  { id: "America/Toronto", name: "America/Toronto (GMT-5)" },
  { id: "Asia/Tokyo", name: "Asia/Tokyo (GMT+9)" },
  { id: "Asia/Shanghai", name: "Asia/Shanghai (GMT+8)" },
  { id: "Asia/Dubai", name: "Asia/Dubai (GMT+4)" },
  { id: "Australia/Sydney", name: "Australia/Sydney (GMT+10)" },
  { id: "Pacific/Auckland", name: "Pacific/Auckland (GMT+12)" },
  { id: "UTC", name: "UTC (GMT+0)" },
];
